class Intro {
    constructor() {
        this.context = null;
        this.pageActive = {};

        TweenMax.to('.btn-link-scroll span', 1.5, { delay: 2, top: -61, yoyo: true, repeat: -1, ease: Power0.easeNone });

    }

    start(page) {
        this.pageActive[page] = true;
        this[page]();
        $("#container").addClass("hide-footer");
        this.context.removeClass('animate-out');
    }

    reset(page) {
        this.pageActive[page] = false;
        $("#container").removeClass("hide-footer");
        this.context && this.context.removeClass('animate-in');
        this.context && this.context.addClass('animate-out');
        this.context && this.context.find('.active').removeClass('active');
    }

    intro1() {

        this.context = $('.section-page__intro');
        this.context.addClass('animate-intro');
        this.context.find('.obj0-tit').addClass('active');
        this.context.find('.obj0-chr1').addClass('active');
        this.context.find('.obj0-chr2').addClass('active');
        this.context.find('.obj0-chr3').addClass('active');
        this.context.find('.obj0-chr4').addClass('active');
        this.context.find('.obj0-chr5').addClass('active');
        this.context.find('.obj0-chr6').addClass('active');
        this.context.find('.obj0-chr7').addClass('active');
        this.context.find('.cmplay').addClass('active');
        this.context.find('.btn-link-scroll').addClass('active');
        this.context.find('.copyright').addClass('active');
        this.context.find('.quick-links').addClass('active');
        this.context.find('.btn-link-reservation').addClass('active');
    }

}

export default Intro;


// WEBPACK FOOTER //
// ./history/2017/171206_flamedragon/_src/js/page/intro.js